<template>
  <div class="open-time">
    <h1 class="m-font-1">票务信息</h1>
    <div class="open-content">
      <div class="date m-font-5 pf-light ml-36">免费开放，须提前预约门票</div>

      <div class="child-hall">
        <div class="date m-font-5 pf-normal mb-50">预约方式</div>
        <div class="week m-font-2 mb-23">我馆实行实名认证在线预约订票方式</div>

        <div class="icon-list">
          <div class="icon-item" v-for="(item, i) in focusList" :key="i">
            <div class="close mb-20">{{ item.name }}</div>
            <img :src="item.url" alt="">

            <div class="pic-pop anim">
              <div class="pic">
                <img :src="item.qrcode" alt="" title="">
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="flex-box flex-row">
          <div class="icon-item m-font-8">
            <div class="close">微信公众号预约</div>
            <img src="../../assets/images/icon_wechat@2x.png" alt="">
            <div class="pic-pop anim">
              <div class="pic">
                <img src="@images/code-wechat.png" alt="" title="">
              </div>
            </div>
          </div>

          <div class="icon-item m-font-8">
            <div class="close">微信小程序预约</div>
            <img src="../../assets/images/icon_Applet@2x.png" alt="">
            <div class="pic-pop anim">
              <div class="pic">
                <img src="@images/code-wechat.png" alt="" title="">
              </div>
            </div>
          </div>

          <div class="icon-item m-font-8">
            <div class="close">美团预约</div>
            <img src="../../assets/images/icon_meituan@2x.png" alt="">
            <div class="pic-pop anim">
              <div class="pic">
                <img src="@images/weibo.png" alt="" title="">
              </div>
            </div>
          </div>

        </div> -->
      </div>

      <div class="box  m-font-2">
        <div class="date m-font-1 mb-50">预约注意事项</div>
        <!-- “数字辽博”小程序、 -->
        <p class="mb-50">1、观众可通过“辽博预约”微信小程序、“辽宁省博物馆”微信公众号或“辽宁省博物馆预约”支付宝小程序进行门票预约；</p>
        <p class="mb-50">2、参观门票当日当次有效；</p>
        <p class="mb-50">
          3、观众凭本人二代身份证按照预约系统提示操作进行预约，每个证件号每日限定预约1张参观门票（可携带1名6岁或1.4m以下儿童参观），每个账户每天限定预约5张门票，认真填写身份信息，选择参观日期、参观时段、门票数量，确认信息填写无误后，提交订单；
        </p>
        <p>4、前往儿童体验馆参观体验的观众（儿童年龄范围：3 - 12 岁）需同时预约辽宁省博物馆参观门票，否则无法入馆。</p>
      </div>

      <div class="child-hall m-font-2">
        <div class="date m-font-1 mb-50">预约流程</div>
        <p class="mb-50">
          1、预约「辽宁省博物馆」的观众请在参观当日的预约时间段内，携带本人二代身份证，在西门入口处，扫描身份证进馆参观；
        </p>
        <p class="mb-50">
          2、预约「儿童体验馆」的观众请在参观当日的预约时间段内，凭预约码在儿童体验馆入口处验码进馆参观。
        </p>
      </div>

    </div>
  </div>
</template>

<script>
export default {

  data() {
    return {
      focusList: [
       {
          name: '微信小程序预约',
          url: require('@images/icon_Applet@2x.png'),
          qrcode: require('@images/wechat.jpg'),
        },
        {
          name: '微信公众号预约',
          url: require('@images/icon_wechat@2x.png'),
          qrcode: require('@images/code-wechat.png'),
        },
        // {
        //   name: '链接',
        //   url: require('@images/foot-link.png'),
        //   qrcode: require('@images/foot-webo.png'),
        // },
        {
          name: '支付宝小程序预约',
          url: require('@images/icon_zhifubao.png'),
          qrcode: require('@images/alipay.jpg'),
        },
      ],
    };
  },

  mounted() {

  },

  methods: {

  },
};
</script>

<style lang="scss" scoped>
.open-time {
  width: 100%;
  h1 {
    margin: 0 36px 55px;
    font-weight: 400;
    color: #010101;
  }

  .ml-36 {
    margin-left: 36px;
  }

  .mb-36 {
    margin-bottom: 36px;
  }

  .mb-50 {
    margin-bottom: 50px;
  }

  .mb-33 {
    margin-bottom: 33px;
  }

  .mb-23 {
    margin-bottom: 23px;
  }

  .open-content {
    .date {
      font-weight: 400;
      color: #010101;
    }

    .ml-40 {
      margin-left: 40px;
    }

    .week,
    .close {
      font-family: PF-light;
      font-weight: 400;
      color: #010101;
    }

    .child-hall {
      background: #f6f6f6;
      padding: 38px 40px 37px;
      margin: 33px 0 73px;
    }

    .icon-list {
      margin-top: 15px;
      display: flex;
      .icon-item {
        position: relative;
        margin-right: 42px;
        cursor: pointer;
        &:last-child{
          margin-right: 0;
        }
        img {
          width: 105px;
          height: 105px;
          object-fit: contain;
        }

        .pic-pop.anim {
          position: absolute;
          left: 0;
          bottom: 120px;
          z-index: 3;
          margin-bottom: 10px;
          opacity: 0;
          padding: 8px;
          visibility: hidden;
          border-radius: 5px;
          // transition: all 0.3s;
          background: #fff;
          &::before {
            content: '';
            width: 12px;
            height: 12px;
            background-color: #fff;
            border: 1px solid #ddd;
            position: absolute;
            z-index: -1;
            left: 50%;
            top: 100%;
            transform: translate(-50%, -50%) rotate(45deg);
          }
          &:after {
            content: '';
            position: absolute;
            z-index: -1;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            background-color: #fff;
            border-radius: 5px;
          }
          .pic {
            width: 150px;
            img {
              width: 100%;
              height: 150px;
            }
          }
        }
        &:hover {
          .pic-pop {
            opacity: 1;
            visibility: visible;
          }
          .pic-pop.anim {
            transform: translate(-34px, 0%);
          }
        }
      }
    }


    .close {
      display: flex;
      align-items: center;
      &::before {
        content: '';
        display: block;
        background: #ae8148;
        position: relative;
        top: 2px;
        width: 4px;
        height: 30px;
        margin-right: 9px;
      }
    }

    .box {
      margin: 34px 48px 77px 40px;
    }

    p {
      // font-size: 16px;
      font-family: PF-light;
      font-weight: 400;
      color: #010101;
      line-height: 48px;
    }
  }
}
</style>